/* eslint-disable no-use-before-define */
import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import App from "./app";

if (process.env.REACT_APP_ENV !== "development") {
  Sentry.init({
    dsn: "https://81188857fb88462a998714451c41e063@sentry.configr.com/26",
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.querySelector("#cloudez-chat"),
);
